module.exports = __webpack_public_path__ + "cc36d1d28538f663b42bd42d7562c074.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-10.cur
// module id = 429
// module chunks = 0